export default __webpack_public_path__ + "static/media/srbwi-logo.2bb5b95b.png";